import { Tag, Typography, Space } from "antd";

const { Text } = Typography;
const columns = [
  {
    title: "تاریخ ثبت",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 110,
    sorter: true,
  },
  {
    title: "نام",
    dataIndex: "name",
    key: "name",
    width: 180,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "دسته بندی",
    dataIndex: "category",
    key: "category",
    sorter: true,
    width: 160,
    render: (_,  {category : cat} ) => {
      return (
      <>
            <p key={cat}>
              {cat === "WORK_SPACE"
                ? "فضای کار"
                : cat === "CLASS"
                ? "دوره‌های آموزشی"
                : cat === "EVENT"
                ? "رویداد"
                : cat === "CONSULTATION"
                ? "مشاوره"
                : cat === "MEETING_ROOM"
                ? "اتاق جلسات"
                : "نامشخص"}
            </p>
      </>
    )
  }
  },

  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true,
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 100,
  },
];

export default columns;
